/* PREVIEW COMPONENT **********************************************************/

// react redux
import React, { Component, PropTypes } from 'react'
import ReactDOM from 'react-dom'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { translate } from 'react-i18next'

/* 3rd party Tools */
import _ from 'lodash'

/* utils */
import { formatTime } from 'util/string'

/* Widgets */
import { Icon, ICON, SCHEME as ICON_SCHEME } from 'widget/icon'

/* Actions */
import { showModal, hideModal } from 'react-redux/actions/modal'

/* Selectors */
import { getItem } from 'react-redux/selectors/asset'

/* Styles */
import "./preview.css"

class AssetPreview extends Component {

  constructor(props) {
    super(props)
    this.state = {
      parentWidth: 0,
      parentHeight: 0,
      mediaWidth: 0,
      mediaHeight: 0,
      videoPaused: false,
      videoMuted: false,
      loaded: false,
      videoDuration: 0
    }
  }

  componentDidMount() {
    var node = ReactDOM.findDOMNode(this)
    node.focus()
    this.keyDownListener = this.onKeyDown.bind(this)
    this.resizeListener = this.onResize.bind(this)
    window.addEventListener('keydown', this.keyDownListener)
    window.addEventListener('resize', this.resizeListener)
    this.onResize()
  }

  componentWillUnmount() {
    window.removeEventListener('keydown', this.keyDownListener)
    window.removeEventListener("resize", this.resizeListener)
  }

  onResize(e) {
    this.setState({
      parentWidth: this.root.parentNode.offsetWidth,
      parentHeight: this.root.parentNode.offsetHeight
    })
  }

  onKeyDown(e) {
    switch (e.keyCode) {
      case 27: // esc
        e.preventDefault()
        e.stopPropagation()
        this.cancel()
        break
    }
  }

  cancel() {
    const { hideModal } = this.props
    hideModal()
  }

  onVideoMetadataLoad(e) {
    this.setState({
      mediaWidth: e.target.videoWidth,
      mediaHeight: e.target.videoHeight,
      loaded: true
    })
  }

  onImageLoad(e) {
    this.setState({
      mediaWidth: e.target.naturalWidth,
      mediaHeight: e.target.naturalHeight,
      loaded: true
    })
  }

  onVideoTimeUpdate(e) {
    this.updatePlayhead()
    this.updateBuffer() // buffer update necessary since onProgress stops firing
  }

  onVideoProgress(e) {
    this.updateBuffer()
  }

  onVideoDurationChange(e) {
    this.setState({videoDuration: e.target.duration})
    //const duration = formatTime(e.target.duration)
    //this.videoDuration.innerHTML = duration
  }

  onVideoLoadedData(e) {
  }

  onVideoLoadStart(e) {
  }

  onVideoPlaying(e) {
  }

  onVideoVolumeChange(e) {
  }

  onVideoSeeked(e) {
  }

  onTogglePauseClick(e) {
    if (this.video.paused) this.video.play()
    else this.video.pause()
    this.setState({ videoPaused: this.video.paused })
  }

  onToggleMuteClick(e) {
    this.video.muted = !this.video.muted
    this.setState({ videoMuted: this.video.muted })
  }

  onSeek(e) {
    let seekTime = 0
    const rect = this.bar.getBoundingClientRect();
    seekTime = Math.max(
      0,
      Math.min(
        this.state.videoDuration,
        this.state.videoDuration
        * (e.clientX - rect.left) / this.bar.offsetWidth
      )
    )
    this.video.currentTime = seekTime
  }

  /**
  * Updates the playhead position
  * Settings innerhtml of time display and modifies style of scrub bar
  * React Performance Issue led to this solution
  * @HACK This is not react best practice but more performant on my machine
  **/
  updatePlayhead() {
    const playback = Math.max(
      0,
      Math.min(100, this.video.currentTime / this.state.videoDuration * 100)
    )
    this.playhead.style.width = playback + "%"
    const time = formatTime(this.video.currentTime)
    this.videoTime.innerHTML = time
  }

  /**
  * Updates the buffer indicator
  * Modifies style of buffer bar
  * React Performance Issue led to this solution
  * @HACK This is not react best practice but more performant on my machine
  * @TODO Implement multiple buffer regions
  **/
  updateBuffer() {
    if (!this.progress) return
    let loaded = 0
    if (this.video.buffered.length) {
      loaded = Math.max(
        0,
        Math.min(
          100,
          this.video.buffered.end(0) / this.state.videoDuration * 100
        )
      )
    }
    this.progress.style.width = loaded + "%"
  }

  renderVideoBar() {
    return (
      <div
        className="video-bar"
        ref={ (ref) => { this.bar = ref} }
        onClick={ this.onSeek.bind(this) }
      >
        <div
          className="video-progress"
          ref={ (ref) => { this.progress = ref} }
          style={ {width: 0 + "%" }}
        ></div>
        <div
          className="video-playhead"
          ref={ (ref) => { this.playhead = ref} }
          style={ {width: 0 + "%" }}
        ></div>
      </div>
    )
  }

  renderTogglePauseIcon() {
    const { videoPaused } = this.state
    if (videoPaused) return <Icon
      icon={ ICON.PLAY }
      size={ 36 }
      interactive={ true }/>
    return <Icon icon={ ICON.PAUSE } size={ 36 } interactive={ true }/>
  }

  renderToggleMuteIcon() {
    const { videoMuted } = this.state
    if (videoMuted) return (
      <Icon icon={ ICON.SOUND_MUTE } size={ 36 } interactive={ true }/>
    )
    return <Icon icon={ ICON.SOUND } size={ 36 } interactive={ true }/>
  }

  renderVideoControls() {
    if (!this.state.loaded) return
    const time = formatTime(0)
    const duration = formatTime(this.state.videoDuration)
    return (
      <div className="video-controls">
        <button
            onClick={ this.onTogglePauseClick.bind(this) }
        >
          { this.renderTogglePauseIcon() }
        </button>
        { this.renderVideoBar() }
        <div
          className="video-time"
          ref={ (ref) => { this.videoTime = ref } }
        >
          { time }
        </div>
        <div> | </div>
        <div
          className="video-duration"
          ref={ (ref) => { this.videoDuration = ref } }
        >
          { duration }
        </div>
        <button
            onClick={ this.onToggleMuteClick.bind(this) }
        >
          { this.renderToggleMuteIcon() }
        </button>
      </div>
    )
  }

  renderSpinner() {
    if (this.state.loaded) return
    const { t } =  this.props
    return (
      <Icon
        icon={ ICON.LOADING_SYNC }
        className="spinner"
        spin={ true }
        title={ t("notification:icon.process") }
        size={ 36 }
        circle={ true }
        scheme={ ICON_SCHEME.DEFAULT }
        interactive={ false }
      />
    )
  }

  renderMedia() {
    const { selectedAsset, fileName, uid, preview, raw } =  this.props
    const {
      parentWidth,
      parentHeight,
      mediaWidth,
      mediaHeight
    } = this.state
    // Calculating maximum dimensions of media content
    const maxHeight = Math.min(parentHeight-164, parentHeight * .8)
    const maxWidth = Math.min(parentWidth-48, parentWidth * .8)
    const scale = Math.min(
      1, // never upscale
      Math.min(maxWidth/mediaWidth, maxHeight/mediaHeight)
    )
    if (preview || raw) {
      // TODO: assemble filepath within api
      const filePath = (preview)?preview.url:raw.url
      const mime = (preview)?preview.mimeType:raw.mimeType

      if (/^video/.test(mime)) {
          return (
            <div className="video-container" ><video
                ref={ (ref) => { this.video = ref } }
                width={ mediaWidth * scale }
                height={ mediaHeight * scale }
                className="video-preview"
                preload="auto"
                onLoadedMetadata={ this.onVideoMetadataLoad.bind(this) }
                onTimeUpdate={ this.onVideoTimeUpdate.bind(this) }
                onProgress={ this.onVideoProgress.bind(this) }
                onDurationChange={ this.onVideoDurationChange.bind(this) }
                onLoadedData={ this.onVideoLoadedData.bind(this) }
                onLoadStart={ this.onVideoLoadStart.bind(this) }
                onPlaying={ this.onVideoPlaying.bind(this) }
                onVolumeChange={ this.onVideoVolumeChange.bind(this) }
                onSeeked={ this.onVideoSeeked.bind(this) }

                autoPlay
                loop
                >
                <source src={filePath} type={mime} />
              </video>{ this.renderVideoControls() }</div>
          )
        } else if (/^image/.test(mime)) {
          return (<img
            className="image-preview"
            src={ filePath }
            width={ mediaWidth * scale }
            height={ mediaHeight * scale }
            onLoad={ this.onImageLoad.bind(this) }
          />)
        }
    } else {
      return null
    }
  }

  render() {
    const { props } = this
    const { name, fileName, t } = props
    return (
      <div
        className="asset-preview component modal-frame"
        ref={ (ref) => { this.root = ref } }
      >
        <h2 className="modal-title">
          { t("asset:preview.title", { name: name || fileName }) }
        </h2>
        <div
          className="modal-body"
          ref={ (ref) => { this.body = ref } }
        >{ this.renderMedia() }{ this.renderSpinner() }</div>
      </div>
    )
  }
}

AssetPreview.propTypes = {
  uid: PropTypes.string.isRequired,
}

const mapStateToProps = (state) => {
  return state
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      showModal,
      hideModal
    },
    dispatch
  )
}

function mergeProps(stateProps, dispatchProps, ownProps){
  return Object.assign(
    {},
    dispatchProps,
    getItem(stateProps, ownProps.uid),
    ownProps
  )
}

const reduxComponent = connect(
  mapStateToProps,
  mapDispatchToProps,
  mergeProps
)(AssetPreview)
const translatedComponent = translate([], { withRef: true })(reduxComponent)
export default translatedComponent



// WEBPACK FOOTER //
// ./src/app/component/asset/preview.jsx